export const filterInvoicesDataByText = (invoices, textSearch) => {
  return invoices.filter(element => {
    if (textSearch.trim() === "") {
      return true;
    }

    const terms = textSearch.trim().toLowerCase().split(" ");
    const adapt = d => (d != null ? String(d).toLowerCase() : "");

    let rowData =
      adapt(element.buscador) +
      adapt(element.concept) +
      adapt(element.nameClient) +
      adapt(element.dniClient) +
      adapt(element.taskReference);

    return terms.every(t => {
      if (terms.length > 1 || t.length > 2) {
        const rowDataPlus = rowData + adapt(element.numInvoice);
        return rowDataPlus.includes(t);
      }
      return rowData.includes(t);
    });
  });
};